/*
 * @Author: cpb
 * @Date: 2020-07-24 15:58:23
 * @Last Modified by: lhr
 * @Last Modified time: 2021-07-08 17:18:27
 * @Desc: 目前此项目没使用(使用了isLogin leagueId)
 */

import Vue from "vue";
// ! FIXE 此处造成webpack 解析依赖时， requestRepayment 比request.js文件早，导致引用import {a} from request.js a为undefined
// ! 先注释
// import { login, getInfo } from "@/api/user";

import { ACCESS_TOKEN } from "@/store/mutation-types";

const user = {
  state: {
    token: "",
    name: "",
    welcome: "",
    avatar: "",
    code:'',//
    leagueName:'',//
    haveApply:false,//是否有申请订单
    isFinish:false,//用于是否要提示框
    roles: [],
    info: {},
    bankInfo:null,
    isLogin: false,
    leagueId: "", // 专属首页进来携带机构id
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name;
      state.welcome = welcome;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_INFO: (state, info) => {
      state.info = info;
    },
    SET_ISLOGIN: (state, isLogin) => {
      state.isLogin = isLogin;
    },
    SET_LEAGUEID: (state, leagueId) => {
      state.leagueId = leagueId;
    },
    SET_BANKINFO: (state, bankInfo) => {
      console.log(bankInfo,'设置-')
      state.bankInfo = bankInfo;
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((response) => {
            if (response.success) {
              if (response.data.manageType == 1) {
                const result = response.data;
                const opId = result.opId;
                Vue.ls.set(ACCESS_TOKEN, opId, 31 * 24 * 60 * 60 * 1000);
                commit("SET_TOKEN", opId);
              }

              resolve(response);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then((response) => {
            const result = response.result;

            if (result.role && result.role.permissions.length > 0) {
              const role = result.role;
              role.permissions = result.role.permissions;
              role.permissions.map((per) => {
                if (
                  per.actionEntitySet != null &&
                  per.actionEntitySet.length > 0
                ) {
                  const action = per.actionEntitySet.map((action) => {
                    return action.action;
                  });
                  per.actionList = action;
                }
              });
              role.permissionList = role.permissions.map((permission) => {
                return permission.permissionId;
              });
              commit("SET_ROLES", result.role);
              commit("SET_INFO", result);
            } else {
              reject(new Error("getInfo: roles must be a non-null array !"));
            }

            // commit("SET_NAME", { name: result.name, welcome: welcome() });
            // commit("SET_AVATAR", result.avatar);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 登出
    Logout({ commit }) {
      return new Promise((resolve) => {
        commit("SET_TOKEN", "");
        commit("SET_ROLES", []);
        Vue.ls.remove(ACCESS_TOKEN);

        resolve();
      });
    },
    // 登录状态
    SetIsLogin({ commit }, isLogin) {    
      commit("SET_ISLOGIN", isLogin);
    },
    setBankInfo({ commit }, bankInfo) {
      console.log(bankInfo,'设置------------')
      commit("SET_BANKINFO", bankInfo);
    },
  },
};

export default user;
